import { formatDate } from '@ynap/intl-formatters';

export default function getuserDetails(state) {
    let dateOfBirthGroup = {};
    let dateOfBirth = null;
    const { user = {}, locale, updateUserSuccess, fetchUserError, consentDatestamp } = state;

    if (user.dateOfBirth) {
        const dob = user.dateOfBirth.slice(0, 10);

        // Safari seems to get upset about us trying to do fancy date arithmetic with timezones.
        // Given we only really care about the D/M/Y parts, it's simpler to split those out as a string and use them as-is.
        let [dobYear, dobMonth, dobDay] = dob.split('-');

        // year is optional
        if (dobYear === '1900') {
            dobYear = null;
        }

        const dateFormatOptions = dobYear === null ? { month: 'short', day: 'numeric' } : { year: 'numeric', month: 'short', day: 'numeric' };

        // month is zero-indexed, because of course it is...
        const dateObj = new Date(dobYear, dobMonth - 1, dobDay);
        dateOfBirth = formatDate(dateObj, dateFormatOptions, locale.id);

        dateOfBirthGroup = {
            day: dobDay,
            month: dobMonth,
            year: dobYear,
        };
    }

    return {
        logonId: user.logonId,
        title: user.personTitle,
        firstName: user.firstName,
        lastName: user.lastName,
        dateOfBirth,
        dateOfBirthGroup,
        inMigration: !!user.inMigration,
        consentDatestamp,
        updateUserSuccess,
        fetchUserError,
    };
}
